import React, { FC } from 'react';
import { Button } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
import { darken, makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { Network } from 'api';
import { CustomSVG, ICustomSVG } from 'components';

interface IProps extends ButtonProps {
  target?: string;
  text: string;
  network: Network;
}

const useStyles = makeStyles(theme => ({
  button: {
    padding: theme.spacing(0.5, 2),
    color: theme.palette.common.white,
    border: 'none',
    borderRadius: theme.spacing(4),
  },
  twitter: {
    backgroundColor: theme.custom.networks.twitter,
    '&:hover': {
      backgroundColor: darken(theme.custom.networks.twitter, 0.1),
    },
  },
  linkedin: {
    backgroundColor: theme.custom.networks.linkedin,
    '&:hover': {
      backgroundColor: darken(theme.custom.networks.linkedin, 0.1),
    },
  },
  facebook: {
    backgroundColor: theme.custom.networks.facebook,
    '&:hover': {
      backgroundColor: darken(theme.custom.networks.facebook, 0.1),
    },
  },
  youtube: {
    backgroundColor: theme.custom.networks.youtube,
    '&:hover': {
      backgroundColor: darken(theme.custom.networks.youtube, 0.1),
    },
  },
  instagram: {
    ...theme.custom.networks.instagram,
    borderRadius: 16,
    '&:hover': {
      opacity: '1.1',
    },
  },
}));

const SocialButton: FC<IProps> = ({ network, text, ...rest }) => {
  const classes = useStyles();
  const networkLowercase = network.toLowerCase();
  const networkIconName = `${networkLowercase}Rounded`;

  return (
    <Button
      variant="contained"
      className={classNames(classes.button, classes[networkLowercase])}
      endIcon={<CustomSVG name={networkIconName as keyof ICustomSVG} size={16} />}
      {...rest}
    >
      {text}
    </Button>
  );
};

export default SocialButton;
